import React, { useState } from "react";
import {
  useScreen,
  useResend,
  submitEmailChallenge,
  returnToPrevious,
  useErrors,
} from "@auth0/auth0-acul-react/email-identifier-challenge";

const EmailIdentifierChallengeScreen: React.FC = () => {
  const [code, setCode] = useState("");
  const { texts } = useScreen();
  const { hasError, errors } = useErrors();
  const { disabled, startResend } = useResend();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await submitEmailChallenge({ code });
  };

  const handleResend = (e: React.FormEvent) => {
    e.preventDefault();
    startResend();
  };

  const handleReturn = async (e: React.FormEvent) => {
    e.preventDefault();
    await returnToPrevious();
  };

  return (
    <div className="acul-card">
      <h2>Email Identifier Challenge</h2>
      <p>{texts?.emailDescription ?? "Enter the verification code sent to your email."}</p>

      <form onSubmit={handleSubmit}>
        <label htmlFor="code">{texts?.placeholder ?? "Enter the 6-digit code"}</label>
        <input
          id="code"
          name="code"
          type="text"
          required
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <button type="submit" className="primary">
          {texts?.buttonText ?? "Continue"}
        </button>
      </form>

      <form onSubmit={handleResend}>
        <button type="submit" disabled={disabled}>
          {disabled ? "Resend Limit Reached" : "Resend Code"}
        </button>
      </form>

      <form onSubmit={handleReturn}>
        <button type="submit">{texts?.backButtonText ?? "Go back"}</button>
      </form>

      {hasError && (
        <div className="acul-error">
          {errors.map((err) => (
            <p key={err.id}>{err.message}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailIdentifierChallengeScreen;
